import { useJson } from '@/hooks/useJson'

export interface WorkoutCount {
  name: string
  count: number
}

export interface AboutStats {
  name: string
  username: string
  image_url: string | null
  location: string | null
  member_since: string
  total_workouts: number
  estimated_cycling_ftp: number
  badge_level: number
  workout_counts: WorkoutCount[]
}

export function useAboutStats() {
  return useJson<AboutStats>('/api/about', 'Failed to load stats')
}
